import {
  get, post, update, get2, upload, download
} from '../helpers'

export function getUser() {
  return get(`/get-user`)
}

export function getJenisCuti() {
  return get(`/jenis-cuti`)
}

export function getStatusPengajuan() {
  return get(`/status-pengajuan`)
}

export function postCuti($data) {
  return post(`/post-cuti`, $data)
}

export function getUserPengaju(uuid) {
  return get(`/get-user-pengaju/${uuid}`)
}

export function getDetailPengajuanCuti(uuid) {
  return get(`/get-detail-pengajuan-cuti/${uuid}`)
}

export function tolakPengajuanCuti($data) {
  return post(`/tolak-cuti`, $data)
}

export function approvePengajuanCuti($data) {
  return post(`/approve-cuti`, $data)
}

export function perbaikanCuti($data) {
  return post(`/perbaikan-cuti`, $data)
}

export function ubahNama($data) {
  return post(`/ubah-nama`, $data)
}

export function ubahPassword($data) {
  return post(`/ubah-password`, $data)
}

export function getAllMaster() {
  return get(`/get-master`, )
}

export function getDetailBiodata() {
  return get(`/get-detail-biodata`, )
}

export function updateBiodata($data) {
  return post(`/update-biodata`, $data)
}


//API FOR ADMIN
export function getUserUUID(uuid) {
  return get(`/get-user-uuid/${uuid}`)
}

export function ubahGeneralUUID($data) {
  return post(`/ubah-general-uuid`, $data)
}

export function getDetailBiodataUUID(uuid) {
  return get(`/get-detail-biodata-uuid/${uuid}`, )
}

export function updateBiodataUUID($data) {
  return post(`/update-biodata-uuid`, $data)
}

export function ubahPasswordUUID($data) {
  return post(`/ubah-password-uuid`, $data)
}

export function getAllMasterUUID() {
  return get(`/get-master-admin`, )
}

export function postPegawaiBaru($data) {
  return post(`/pegawai-baru`, $data)
}

export function exportSisaCuti() {
  return get2(`/export-sisa-cuti`, )
}

export function importSisaCuti(file, metadata, onUploadProgress) {
  return upload('/import-sisa-cuti', file, metadata, onUploadProgress)
}

export function uploadFilePengajuan(file, metadata, onUploadProgress) {
  return upload('/upload-file', file, metadata, onUploadProgress)
}

export function uploadTtd(file, metadata, onUploadProgress) {
  return upload('/upload-ttd', file, metadata, onUploadProgress)
}

export function updateBulkSignatory(data) {
  return post('/update-bulk-signatory', data)
}
export function downloadDokumen(filename) {
  return download(`/download-dokumen/${filename}`)
}
